__turbopack_context__.v({
  "headerOne": "Markdown-module__VGsKbq__headerOne",
  "headerThree": "Markdown-module__VGsKbq__headerThree",
  "headerTwo": "Markdown-module__VGsKbq__headerTwo",
  "list": "Markdown-module__VGsKbq__list",
  "markdownWrapper": "Markdown-module__VGsKbq__markdownWrapper",
  "orderedList": "Markdown-module__VGsKbq__orderedList",
  "paragraph": "Markdown-module__VGsKbq__paragraph",
  "unorderedList": "Markdown-module__VGsKbq__unorderedList",
});
